import React, { useEffect, useState } from 'react'
import DefaultLayout from '../../components/DefaultLayout'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { setUpdatedCart } from '../../redux/auth-reducer'
import styled from 'styled-components'
import Dropdown from './Dropdown'
import { supabase } from '../../App'
import { toast } from 'react-toast'

const Wrapper = styled.div`
    margin: auto;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 100px;
    @media screen and (max-width: 768px) {
        padding-bottom: 50px !important;
    }
`

const Description = styled.p`
    color: #747474;
    line-height: 1.7;
    font-size: 14px;
    margin-top: 1em;
`

const Sizes = styled.div`
    h6 {
        font-size: 14px;
        font-weight: 500;
    }
`

const Main = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 15px;
    @media screen and (max-width: 768px) {
        padding: 0 16px;
        flex-direction: column;
    }
`

const Title = styled.h1`
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    border-bottom: 1px solid #dedede;

    h1 {
        color: #1b1b1b;
        font-size: 27px;
        line-height: 1.4;
        padding-right: 50px;
        margin-bottom: 4px;
        font-weight: 600;
    }
    .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 20px;
    }
    @media screen and (max-width: 768px) {
        justify-content: flex-start !important;
        flex-direction: column;
        h1 {
            font-size: 22px !important;
            padding-right: 20px !important;
        }
    }
`

const Images = styled.div`
    min-width: 710px;
    width: 710px;
    height: 710px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 10px;

    img {
        border-radius: 10px;
        min-height: 100%;
        min-width: 100%;
    }
    @media screen and (max-width: 768px) {
        min-width: 100% !important;
        width: 100% !important;
        height: 100% !important;
    }
`

const Icon = styled.div`
    height: 48px;
    width: 48px;
    display: grid;
    place-content: center;
    transition: 0.2s all ease;
    border-radius: 50%;
    cursor: pointer;
    margin-left: auto;
    svg {
        width: 24px;
        height: 24px;
    }
    &:hover,
    &.active {
        background-color: #f0ebe6;
        path {
            transition: 0.2s all ease;
            fill: red;
        }
    }
`

const Data = styled.div`
    padding-left: 32px;
    width: 100%;
    @media screen and (max-width: 768px) {
        margin-top: 25px;
        padding-left: 0 !important;
    }
`

const Price = styled.div`
    padding-top: 9px;
    font-size: 18px;
    line-height: 1.4;
    display: flex;
    align-items: flex-start;
    font-weight: normal;

    span {
        font-size: 10px;
        line-height: 12px;
        padding: 6px;
        background: #f3f4f5;
        border-radius: 4px;
        margin-left: 5px;
        height: 24px;
    }
`

const Btn = styled.button`
    margin-top: 12px;
    border-radius: 6px 6px 0 0;
    background: #000;
    color: #fff;
    height: 50px;
    width: 100%;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
`

const AddToCart = styled.div`
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;

    span {
        text-align: center;
        padding: 10px;
        padding-top: 10px;
        padding-left: 10px;
        border: solid 1px #c1c1c1;
        border-radius: 0 0 6px 6px;
        border-top: none;
        background: #fbfbfb;
        margin: 0;
        width: 100%;
    }
`

const Info = styled.div`
    margin-bottom: 15px;
    padding: 20px 0;

    a {
        pointer-events: auto;
        opacity: 1;
        text-decoration: none;
        color: #1b1b1b;
        position: relative;

        &::before {
            content: '';
            width: 100%;
            height: 1px;
            position: absolute;
            bottom: -1px;
            left: 0;
            transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
            transform: scaleX(1);
            transform-origin: left center;
            transition-delay: 0.1s;
            background: rgba(193, 193, 193, 0.3);
        }
    }
`

const Stock = styled.div`
    display: flex;
    align-items: flex-start;
    padding-top: 10px;

    h6 {
        font-weight: 600;
    }

    h6,
    p {
        font-size: 12px;
        line-height: 1.6;
        color: rgb(0 179 44);
    }

    img {
        margin-right: 12px;
        padding-top: 2px;
    }
`

const Details = styled.div`
    padding-top: 20px;
    padding-bottom: 32px;

    p {
        font-size: 14px;
        line-height: 1.71em;
    }

    ul {
        margin-top: 1em;
        padding-left: 40px;
    }

    li {
        font-size: 14px;
        line-height: 1.71em;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: -15px;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            display: block;
            border-radius: 50%;
            background: #000;
        }
    }
`

const Dropdowns = styled.div``

const Breadcrumbs = styled.p`
    font-size: 12px;
    color: #747474;

    span {
        margin: 0 10px;
    }
    @media screen and (max-width: 768px) {
        padding: 0 16px;
        margin: 30px 0 20px;
    }
`

const Seller = styled.div`
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: auto;
    img {
        width: 46px;
    }
    h2 {
        text-transform: uppercase;
        margin-left: 10px;
        font-size: 18px;
        font-weight: 600;
    }
`

const Product = (props) => {
    const [product, setProduct] = useState(null)
    const [size, setSize] = useState(1)
    const [fav, setFav] = useState(false)

    useEffect(() => {
        getGoodData()
    }, [0])

    const addToCart = (product) => {
        if (size) {
            props.setUpdatedCart({
                id: product.id,
                name: product.title,
                price: product.cost,
                image: product.images[0],
            })
            toast.success('Successfully added')
        } else {
            // подсвечивать выбор размера
        }
    }

    const getGoodData = async () => {
        const { data, error } = await supabase
            .from('products')
            .select(
                `
					*,
					seller:sellers (
						first_name,
						second_name,
						name,
						logo
					)
				`
            )
            .eq('id', props.match.params.productId)
            .single()

        if (data) {
            setProduct(data)
        }

        if (error) {
            // 404 продук не найден
        }
    }

    const images = product?.images.map((i) => {
        return {
            original: i,
            thumbnail: i,
        }
    })

    if (!product) {
        return null
    }

    return (
        <DefaultLayout>
            <Wrapper className="container">
                <Breadcrumbs>
                    Armani <span>&gt;</span> Футболки <span>&gt;</span>{' '}
                    {product.title ?? 'Untitled'}
                </Breadcrumbs>
                <Main>
                    <Images>
                        <img src={product.images[0]} alt="" />
                    </Images>

                    <Data>
                        <Title>
                            <div className="row">
                                <h1>{product.title ?? 'Untitled'}</h1>

                                <Price>
                                    ${product.cost} <span>USD</span>
                                </Price>
                            </div>
                            <Icon
                                className={fav ? 'active' : ''}
                                onClick={() => {
                                    setFav(!fav)
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className="fav"
                                >
                                    <path d="M12 22a1.42 1.42 0 01-.91-.34l-.09-.07-8.87-9.17C.52 10.77 0 9.72 0 8.09a6.17 6.17 0 011-3.37 5.88 5.88 0 012.65-2.25 5.74 5.74 0 013.45-.35 5.9 5.9 0 013 1.68L12 5.72l1.86-1.92a5.9 5.9 0 013-1.68 5.75 5.75 0 013.45.35A5.88 5.88 0 0123 4.72a6.17 6.17 0 011 3.37c0 1.6-.54 2.7-2.15 4.36l-8.94 9.21A1.43 1.43 0 0112 22zM5.93 4a3.65 3.65 0 00-1.49.31 3.91 3.91 0 00-1.77 1.5A4.14 4.14 0 002 8.09c0 1 .24 1.58 1.56 2.93L12 19.74l8.42-8.68C21.77 9.66 22 9 22 8.09a4.2 4.2 0 00-.67-2.29 4 4 0 00-1.77-1.49 3.7 3.7 0 00-2.25-.23 3.8 3.8 0 00-2 1.11L12 8.59l-3.3-3.4a3.8 3.8 0 00-2-1.11A3.92 3.92 0 005.93 4z"></path>
                                </svg>
                            </Icon>
                        </Title>

                        <Info>
                            <Sizes>
                                <h6>Размер</h6>
                            </Sizes>
                            <Description>
                                Черный ясень — это изысканная матовая отделка из
                                черного дерева, придающая изделию современный и
                                элегантный вид.
                            </Description>
                            <Description>
                                Все еще сомневаетесь какой размер взять?{' '}
                                <a href="">Подобрать</a>
                            </Description>
                        </Info>
                        <AddToCart>
                            <Btn onClick={() => addToCart(product)}>
                                В корзину
                            </Btn>
                            <span>
                                Скидка применяется автоматически при оформлении
                                заказа.
                            </span>
                        </AddToCart>
                        <Stock>
                            <img src="" alt="" />
                            <div>
                                <h6>В наличие</h6>
                                <p>Доставка между Вт 05:31 и Ср 06:01</p>
                            </div>
                        </Stock>
                        <Details>
                            {/* <p>
								Сделанная из натурального дерева, крышка центральной консоли Hills — это вневременной аксессуар, замысловато разработанный и специально созданный для того, чтобы подчеркнуть интерьер Tesla и сделать его уникальным и совершенным. Крышка центральной консоли Hills предназначена для Model 3 и Model Y.
							</p> */}
                            <ul>
                                <li>
                                    Сделано в Германии из натурального дерева
                                </li>
                                <li>Нет отражения или отпечатков пальцев</li>
                                <li>УФ защитное покрытие</li>
                                <li>Легко чистить и служить долго</li>
                            </ul>
                        </Details>
                        <Dropdowns>
                            <Dropdown></Dropdown>
                            <Dropdown></Dropdown>
                        </Dropdowns>
                    </Data>
                </Main>
            </Wrapper>
        </DefaultLayout>
    )
}

let mapStateToProps = (state) => {
    return {}
}

export default compose(
    connect(mapStateToProps, { setUpdatedCart }),
    withRouter
)(Product)

{
    /* <div className="product-page">
    <div className="breadcrumb">
        <div>
            <a href="">{categories[product.category]}</a>
        </div>
        <div>
            <svg
                width="16"
                height="16"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9444 10L6.72218 4.77782L8.27782 3.22218L15.0556 10L8.27782 16.7778L6.72218 15.2222L11.9444 10Z"
                    fill="#878988"
                ></path>
            </svg>
        </div>
        <div>{product.title ?? 'Untitled'}</div>
    </div>
    <div className="goods-content">
        <div>
            <div className="goods-main">
                <div>
                    <ImageGallery
                        items={images}
                        showPlayButton={false}
                        showNav={false}
                        originalHeight={100}
                    />
                </div>
                <div>
                    <h1>{product.title ?? 'New Item'}</h1>
                    <div className="goods-section">
                        <h2>Description</h2>
                        <p>
                            {product.description ?? 'No description'}
                        </p>
                    </div>
                    <Sizes>
                        {
                            Object.keys(product.sizes).map(size => (
                                <div>
                                    {size} - {product.sizes[size].count} штук
                                </div>
                            ))
                        }
                    </Sizes>
                    <div className="goods-section">
                        <h2>Specification</h2>
                        <ul className="goods-specs">
                            <li>
                                <span>Manufacturer</span>
                                <span>{product.manufacture ?? '-'}</span>
                            </li>
                            <li>
                                <span>Series</span>
                                <span>{product.series ?? '-'}</span>
                            </li>
                            <li>
                                <span>Core Count</span>
                                <span>{product.coreCount ?? '-'}</span>
                            </li>
                            <li>
                                <span>Socket</span>
                                <span>{product.socket ?? '-'}</span>
                            </li>
                        </ul>
                        <button className="show-all">
                            Show all
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 21 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M10.5 11.4444L5.27782 6.22218L3.72218 7.77782L10.5 14.5556L17.2778 7.77782L15.7222 6.22218L10.5 11.4444Z"
                                    fill="#6c6ccb"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="goods-details">
            <div className="goods-seller">
                <div>
                    <div className="goods-seller__avatar">
                        <img src="" alt="" />
                    </div>
                    <div>
                        <h3>{product.seller?.first_name ?? 'Unknown'}</h3>
                        <span className="goods-location tiny-info">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 21 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.4998 1.66672C6.824 1.66672 3.83317 4.65756 3.83317 8.32922C3.809 13.7001 10.2465 18.1534 10.4998 18.3334C10.4998 18.3334 17.1907 13.7001 17.1665 8.33339C17.1665 4.65756 14.1757 1.66672 10.4998 1.66672ZM10.4998 11.6667C8.65817 11.6667 7.1665 10.1751 7.1665 8.33339C7.1665 6.49172 8.65817 5.00006 10.4998 5.00006C12.3415 5.00006 13.8332 6.49172 13.8332 8.33339C13.8332 10.1751 12.3415 11.6667 10.4998 11.6667Z"
                                    fill="#787878"
                                ></path>
                            </svg>
                            {product?.seller?.city ?? 'Kokshetau'}
                        </span>
                    </div>
                </div>
                <div>
                    <a href="mailto:nikfedotoff@mail.ru" className="secondary-btn">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#4747be"
                                d="M 19 0 C 8.621094 0 0 7.492188 0 16.90625 C 0 21.460938 2.042969 25.589844 5.3125 28.625 C 4.832031 30.042969 3.8125 31.171875 2.71875 32.0625 C 2.109375 32.558594 1.515625 32.984375 1.03125 33.40625 C 0.789063 33.617188 0.566406 33.804688 0.375 34.09375 C 0.183594 34.382813 -0.0117188 34.882813 0.125 35.375 L 0.25 35.75 L 0.59375 35.96875 C 1.632813 36.558594 2.894531 36.625 4.21875 36.53125 C 5.542969 36.4375 6.972656 36.136719 8.375 35.75 C 10.308594 35.21875 11.964844 34.585938 13.34375 34.03125 C 16.132813 40.5 23.082031 44.8125 31 44.8125 C 32.34375 44.8125 33.699219 44.628906 34.96875 44.4375 C 36.335938 45.042969 42.300781 47.59375 46.4375 47.59375 C 47.625 47.59375 48.546875 47.382813 49.28125 46.96875 L 49.65625 46.75 L 49.75 46.375 C 50.042969 45.304688 49.136719 44.554688 47.96875 43.625 C 46.792969 42.691406 45.238281 41.449219 44.5625 39.71875 C 47.96875 36.578125 49.90625 32.3125 49.90625 27.90625 C 49.90625 20.710938 44.65625 14.210938 37.09375 11.90625 C 34.707031 4.972656 27.457031 0 19 0 Z M 19 2 C 26.617188 2 32.972656 6.398438 35.125 12.40625 C 35.132813 12.429688 35.148438 12.445313 35.15625 12.46875 C 35.167969 12.5 35.175781 12.53125 35.1875 12.5625 C 35.324219 12.957031 35.433594 13.34375 35.53125 13.75 C 35.601563 14.03125 35.636719 14.304688 35.6875 14.59375 C 35.699219 14.667969 35.707031 14.738281 35.71875 14.8125 C 35.761719 15.078125 35.816406 15.355469 35.84375 15.625 C 35.847656 15.664063 35.839844 15.710938 35.84375 15.75 C 35.875 16.128906 35.90625 16.519531 35.90625 16.90625 C 35.90625 17.417969 35.871094 17.90625 35.8125 18.40625 C 35.753906 18.914063 35.675781 19.414063 35.5625 19.90625 C 35.335938 20.875 34.992188 21.796875 34.5625 22.6875 C 34.132813 23.578125 33.613281 24.425781 33 25.21875 C 32.695313 25.613281 32.347656 26.007813 32 26.375 C 31.652344 26.742188 31.292969 27.101563 30.90625 27.4375 C 30.527344 27.769531 30.132813 28.105469 29.71875 28.40625 C 27.617188 29.925781 25.078125 31.003906 22.3125 31.5 C 21.207031 31.699219 20.078125 31.8125 18.90625 31.8125 C 18.230469 31.8125 17.558594 31.777344 16.90625 31.71875 C 16.875 31.714844 16.84375 31.722656 16.8125 31.71875 C 16.726563 31.710938 16.644531 31.695313 16.5625 31.6875 C 16.332031 31.660156 16.09375 31.628906 15.875 31.59375 C 15.578125 31.546875 15.304688 31.5 15.03125 31.4375 L 14.71875 31.34375 L 14.40625 31.46875 C 13.117188 32.011719 10.488281 33.117188 7.84375 33.84375 C 6.519531 34.207031 5.183594 34.480469 4.0625 34.5625 C 3.566406 34.597656 3.359375 34.449219 2.96875 34.40625 C 3.289063 34.15625 3.558594 33.957031 3.96875 33.625 C 5.300781 32.539063 6.941406 30.96875 7.46875 28.625 L 7.59375 28.03125 L 7.15625 27.625 C 3.957031 24.894531 2 21.09375 2 16.90625 C 2 8.71875 9.578125 2 19 2 Z"
                            ></path>
                        </svg>
                    </a>
                </div>
            </div>
            <div className="goods-actions">
                <h2 className="goods-price">{product.cost} мавродиков</h2>
                <span className="tiny-info">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.73374 3.06822C10.0428 2.89015 10.3933 2.79642 10.75 2.79642C11.1067 2.79642 11.4572 2.89015 11.7662 3.06822L11.7679 3.06915L16.265 5.63892L16.2679 5.64057L16.2679 5.64058C16.5177 5.78485 16.7334 5.9802 16.9013 6.21301C16.9428 6.25605 16.9799 6.3048 17.0112 6.35893C17.038 6.40523 17.0593 6.45321 17.0752 6.50209C17.2131 6.78127 17.2854 7.08893 17.2857 7.40147L17.2857 7.40224L17.2857 12.5451V12.5459C17.2853 12.9029 17.1911 13.2535 17.0125 13.5625C16.8338 13.8716 16.577 14.1283 16.2679 14.3068L16.265 14.3084L16.265 14.3084L11.7679 16.8782L11.7663 16.8791C11.5562 17.0002 11.327 17.0822 11.0896 17.1224C10.9876 17.1743 10.8722 17.2036 10.7499 17.2036C10.6275 17.2036 10.512 17.1743 10.4099 17.1223C10.1728 17.0821 9.9437 17.0001 9.73372 16.8791L9.73214 16.8782L5.23503 14.3084L5.23214 14.3068C4.92298 14.1283 4.66619 13.8716 4.48754 13.5625C4.30888 13.2535 4.21465 12.9029 4.21428 12.5459V12.5451V7.40224V7.40147C4.2146 7.08962 4.28655 6.78263 4.42384 6.50396C4.43989 6.45442 4.46137 6.40582 4.48849 6.35893C4.52011 6.30427 4.55757 6.25509 4.59963 6.21174C4.76735 5.97949 4.9827 5.78459 5.23214 5.64058L5.23503 5.63891L5.23503 5.63892L9.73374 3.06822ZM11.4999 15.3037L15.5179 13.0077L15.5189 13.0071C15.5998 12.9602 15.667 12.8929 15.7138 12.8119C15.7607 12.7307 15.7855 12.6387 15.7857 12.5449L15.7857 12.5443V7.93427L11.4999 10.4135V15.3037ZM9.99986 10.4135V15.3036L5.98214 13.0077L5.98109 13.0071C5.9002 12.9602 5.833 12.8929 5.78619 12.8119C5.73923 12.7306 5.71443 12.6385 5.71428 12.5446V7.93445L9.99986 10.4135ZM11.0207 4.36985L15.0106 6.64976L10.7498 9.11446L6.48923 6.64985L10.4792 4.36985L10.4792 4.36986L10.4821 4.36819C10.5636 4.32117 10.656 4.29642 10.75 4.29642C10.844 4.29642 10.9364 4.32117 11.0179 4.36819L11.0178 4.3682L11.0207 4.36985Z"
                            fill="#787878"
                        ></path>
                    </svg>
                    {product.usage ?? 'Unknown'}
                </span>
                <div className="goods-buttons">
                    <button
                        className="secondary-btn like-goods"
                        onClick={() =>
                            toast.error("Can't add it to wishlist")
                        }
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 21 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.8944 17.7111C10.9019 17.704 10.9092 17.6967 10.9163 17.6892L17.1916 11.0692C18.9361 9.18748 18.9361 6.27931 17.1915 4.39764C16.364 3.5081 15.2043 3.00197 13.9893 3.00009C13.0426 3.00119 12.1293 3.30808 11.3801 3.86384C11.167 4.02189 10.9672 4.20007 10.7837 4.39707L10.5012 4.69557L10.2187 4.39707C10.0303 4.19435 9.82724 4.01351 9.6126 3.85467C7.95303 2.62656 5.60303 2.71364 4.03562 4.16997C3.95719 4.24288 3.88143 4.3186 3.80852 4.39707C2.06383 6.27894 2.06383 9.18728 3.80852 11.0692L10.086 17.6892C10.3032 17.9185 10.6652 17.9283 10.8944 17.7111ZM4.90329 10.0437L10.5011 15.9469L16.0967 10.0438C17.3025 8.73758 17.3011 6.72309 16.0925 5.41852C15.5487 4.83441 14.7871 4.50189 13.9891 4.5001C13.1895 4.50158 12.4262 4.83446 11.8812 5.41954L11.8732 5.42813L10.5012 6.87785L9.11976 5.41812C8.03905 4.25498 6.22012 4.18805 5.05686 5.26864M4.90329 10.0437C3.69735 8.73713 3.6989 6.7222 4.90797 5.41747C4.95549 5.36635 5.00529 5.31658 5.05686 5.26864"
                                fill="#ff265a"
                            ></path>
                        </svg>
                    </button>
                    <button
                        className="primary-btn add-to-cart"
                        onClick={() => addToCart(product)}
                    >
                        Add to cart
                    </button>
                </div>
            </div>
        </div>
    </div>
</div> */
}
